import inputIsRequired from "./inputIsRequired";
import { required, percentage, currency, integer, date, ssn, zipcode, phone, composeValidators } from "./validations";

var mapValidation = function mapValidation(element, coApplicantIsActive, conditionalRequirements) {
  var validation = [];
  var isRequired = inputIsRequired(element, coApplicantIsActive, conditionalRequirements);

  if (isRequired) {
    validation.push(required);

    switch (element.get("DataElement").get("DataType")) {
      case "Percentage":
        validation.push(percentage);
        break;

      case "Currency":
        validation.push(currency);
        break;

      case "Integer":
        validation.push(integer);
        break;

      case "String":
        switch (element.get("DataElement").get("Name")) {
          case "Home Phone":
          case "Cell Phone Number":
          case "Employer Phone Number":
          case "Employer2 Phone Number":
            validation.push(phone);
            break;

          case "Address ZipCd":
          case "Previous Address ZipCode":
            validation.push(zipcode);
            break;

          case "Social Security":
            validation.push(ssn);
            break;

          default:
        }

        break;

      case "Date":
        validation.push(date);
        break;

      default:
    }
  }

  return validation;
};

export var composeValidation = function composeValidation(element, coApplicantIsActive, conditionalRequirements) {
  var validators = mapValidation(element, coApplicantIsActive, conditionalRequirements);
  return composeValidators(validators);
};
export default mapValidation;